document.addEventListener('adev-cart-updated', (event) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
        const cart = event.detail;
        cartDrawer.renderContents(cart);
        cartDrawer.open();
    }
});


if (!customElements.get('adev-quantity-selector')) {
    customElements.define('adev-quantity-selector', class adevQuantitySelector extends HTMLElement {
        constructor() {
            super();

            this.quantitySelectorInput = this.querySelector('input[data-adev-quantity-selector="input"]');
            this.decreaseButton = this.querySelector('[data-adev-quantity-selector="decrease"]');
            this.increaseButton = this.querySelector('[data-adev-quantity-selector="increase"]');
        }

        getValue() {
            return parseInt(this.quantitySelectorInput.value, 10);
        }

        connectedCallback() {
            this.decreaseButton.addEventListener('click', this.decreaseQuantity.bind(this));
            this.increaseButton.addEventListener('click', this.increaseQuantity.bind(this));
        }

        decreaseQuantity() {
            const currentValue = parseInt(this.quantitySelectorInput.value, 10);
            this.quantitySelectorInput.value = Math.max(1, currentValue - 1);
            this.dispatchEvent(new Event('change'));
        }

        increaseQuantity() {
            const currentValue = parseInt(this.quantitySelectorInput.value, 10);
            this.quantitySelectorInput.value = currentValue + 1;
            this.dispatchEvent(new Event('change'));
        }

        disconnectedCallback() {
            this.decreaseButton.removeEventListener('click', this.decreaseQuantity.bind(this));
            this.increaseButton.removeEventListener('click', this.increaseQuantity.bind(this));
        }

    });
}

if (!customElements.get('adev-product-card')) {
    customElements.define('adev-product-card', class adevProductCard extends HTMLElement {
        constructor() {
            super();

            this.addToCartEl = this.querySelector('[data-adev-product-card="add-to-cart"]');
        }

        loadingState(isLoading = true) {
            if (isLoading) {
                this.addToCartEl.disabled = true;
                this.addToCartEl.classList.add('is--loading');
            } else {
                this.addToCartEl.disabled = false;
                this.addToCartEl.classList.remove('is--loading');
            }
        }

        handleAddToCart(e) {
            e.preventDefault();
            this.loadingState(true);

            const variantId = this.addToCartEl.dataset.variantId;
            const sellingPlanId = this.addToCartEl.dataset.sellingPlan;
            const quantitySelector = this.querySelector('adev-quantity-selector');
            const quantity = quantitySelector ? quantitySelector.getValue() : 1;

            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);
            if (sellingPlanId) {
                formData.append('selling_plan', sellingPlanId);
            }
            formData.append('sections', 'cart-drawer,cart-icon-bubble');
            formData.append('sections_url', window.location.pathname);

            fetch(window.routes.cart_add_url + '.js', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.json();
            })
            .then(data => {
                this.loadingState(false);
                document.dispatchEvent(new CustomEvent('adev-cart-updated', { detail: data }));
            })
            .catch(error => {
                this.loadingState(false);
                console.error('Error adding to cart:', error);
            });

        }

        connectedCallback() {
            this.addToCartEl.addEventListener('click', this.handleAddToCart.bind(this));
        }

        disconnectedCallback() {
            this.addToCartEl.removeEventListener('click', this.handleAddToCart.bind(this)); 
        }

    });
}

if (!customElements.get('adev-human-readable-time')) {
    customElements.define('adev-human-readable-time', class adevHumanReadableTime extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const data = this.dataset.date; // format: DD/MM/YYYY HH:mm
            if (!data) return;

            // Parse date string
            const [datePart, timePart] = data.split(' ');
            const [day, month, year] = datePart.split('/').map(Number);
            const [hour, minute] = timePart.split(':').map(Number);

            const dateObj = new Date(year, month - 1, day, hour, minute);
            const now = new Date();
            const diffMs = now - dateObj;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMins / 60);
            const diffDays = Math.floor(diffHours / 24);

            let text = '';
            if (diffMins < 1) {
                text = 'just now';
            } else if (diffMins < 60) {
                text = `${diffMins} min${diffMins === 1 ? '' : 's'} ago`;
            } else if (diffHours < 24) {
                text = `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
            } else {
                text = `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
            }

            this.textContent = text;
        }
    })
}

if (!customElements.get('adev-tabs')) {
    customElements.define('adev-tabs', class adevTabs extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-tab="toggle"]').forEach(button => {
                button.addEventListener('click', () => {
                    const id = button.dataset.id;
                    const tab = this.querySelector(`[data-adev-tab="tab"][data-id="${id}"]`);

                    if (!tab) return;

                    if (tab.classList.contains('active')) {
                        tab.classList.remove('active');
						button.classList.remove('active');
                        return;
                    }

					this.querySelectorAll('[data-adev-tab="toggle"].active').forEach(tab => {
						tab.classList.remove('active');
					});

                    this.querySelectorAll('[data-adev-tab="tab"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

					button.classList.add('active');
                    tab.classList.add('active');

                });
            });

            this.querySelectorAll('[data-adev-tab="open"]').forEach(button => {
                button.addEventListener('click', () => {
                    const id = button.dataset.id;
                    const tab = this.querySelector(`[data-adev-tab="tab"][data-id="${id}"]`);

                    if (!tab) return;

                    this.querySelectorAll('[data-adev-tab="open"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

                    this.querySelectorAll('[data-adev-tab="tab"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

					button.classList.add('active');
                    tab.classList.add('active');

                });
            });
        }

    })
}